import { Input } from "antd";

export default function CrrTextarea(props) {
  const { selectField, placeholderText, onChange, setValue } = props;
  return (
    <Input.TextArea
      rows={8}
      className="login-input"
      placeholder={!selectField && placeholderText}
      bordered={false}
      onChange={(e) => {
        setValue(e.target.value);
        onChange && onChange(e.target.value);
      }}
    />
  );
}
